import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=79ec4c37&scoped=true&"
import script from "./Dynamic.vue?vue&type=script&lang=js&"
export * from "./Dynamic.vue?vue&type=script&lang=js&"
import style0 from "./Dynamic.vue?vue&type=style&index=0&id=79ec4c37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec4c37",
  null
  
)

export default component.exports